import { PopupButton } from "@typeform/embed-react";
import Styled from "styled-components";
import { ButtonSize } from "../Button/Button.styles";

export type TypeFormButtonVariant =
  | "primary"
  | "secondaryDark"
  | "secondaryLight"
  | "outline";
export type TextColorVariant = "black" | "white";

export interface TypeFormButtonContainerProps {
  $variant: TypeFormButtonVariant;
  $textColor?: TextColorVariant;
  $size?: ButtonSize;
  $fullWidth?: boolean;
  $disabled?: boolean;
}

export const TypeFormButtonContainer = Styled(
  PopupButton,
)<TypeFormButtonContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: ${(props) => (props.$fullWidth ? "100%" : "auto")};
  border: none;
  color: ${(props) => (props.$textColor ? props.$textColor : "#FFFFFF")};
  font-weight: 640;
  letter-spacing: -0.1px;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: 0px 1px 1px 0px #69B5FF inset, 0px 2px 8px 0px #03030329;
  background: radial-gradient(42.88% 158.65% at 50% 100%, #61B1FF 0%, #1E90FF 100%);
  transition: all 300ms ease;

  &:hover {
    background: radial-gradient(56.39% 208.65% at 50% 50%, #1E90FF 0%, #1277D9 100%);
    box-shadow: 0px 1px 1px 0px #1E90FF inset, 0px 2px 12px 0px #0303033D;
  }

  ${(props) =>
    props.$disabled &&
    `
    color: #7F7F7F;
    background: #E8E8E8;
    box-shadow: none;
    pointer-events: none;
  `}

  ${(props) =>
    props.$variant === "secondaryDark" &&
    `
    color: #111111;
    box-shadow: none;
    box-shadow: 0px 2px 8px 0px #03030329;
    background: #FFFFFF;

    &:disabled {
      background: #212121;
    }

    &:hover {
      background: #FFFFFFA3;
      box-shadow: none;
      box-shadow: 0px 2px 12px 0px #0303033D;
    }
  `}

  ${(props) =>
    props.$variant === "secondaryLight" &&
    `
    color: #FFFFFF;
    background: #030303;
    box-shadow: none;
    box-shadow: 0px 1px 1px 0px #212121 inset, 0px 2px 8px 0px #03030329;

    &:hover {
      background: #2E2E2E;
      box-shadow: none;
      box-shadow: 0px 1px 1px 0px #212121 inset, 0px 2px 12px 0px #0303033D;
    }
  `}

  ${(props) =>
    props.$variant === "outline" &&
    `
    color: #111111;
    background: transparent;
    border: 1px solid #E8E8E8;
    box-shadow: none;
    
    &:hover {
      border: 1px solid #212121;
      background: none;
      box-shadow: none;
    }
  `}

  ${(props) =>
    props.$size === "small" &&
    `
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;

    font-size: 0.875rem;
    line-height: 1.125rem;
  `};

  ${(props) =>
    props.$size === "medium" &&
    `
    padding: 0.5rem 1.25rem;
    border-radius: 0.5rem;

    font-size: 0.875rem;
    line-height: 1.125rem;
  `};

  ${(props) =>
    props.$size === "large" &&
    `
    padding: 0.625rem 1.5rem;
    border-radius: 0.625rem;

    font-size: 1rem;
    line-height: 1.375rem;
  `};

  ${(props) => props.theme.breakpoints.up("medium")} {
    ${(props) =>
      props.$size === "small" &&
      `
      padding: 0.5rem 1rem;
      border-radius: 0.5rem;

      font-size: 1rem;
      line-height: 1.375rem;
    `};

    ${(props) =>
      props.$size === "medium" &&
      `
      padding: 0.75rem 1.5rem;
      border-radius: 0.625rem;

      font-size: 1rem;
      line-height: 1.375rem;
    `};

    ${(props) =>
      props.$size === "large" &&
      `
      padding: 0.75rem 2rem;
      border-radius: 0.75rem;

      font-size: 1.125rem;
      line-height: 1.5rem;
    `};
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    ${(props) =>
      props.$size === "small" &&
      `
      padding: 0.5rem 1rem;
      border-radius: 0.5rem;

      font-size: 1rem;
      line-height: 1.375rem;
    `};

    ${(props) =>
      props.$size === "medium" &&
      `
      padding: 0.75rem 2rem;
      border-radius: 0.625rem;

      font-size: 1rem;
      line-height: 1.375rem;
    `};

    ${(props) =>
      props.$size === "large" &&
      `
      padding: 0.75rem 2.5rem;
      border-radius: 0.75rem;

      font-size: 1.125rem;
      line-height: 1.5rem;
    `};
  }
`;
